"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Topic = _interopRequireDefault(require("./Topic.scss"));

var _CordovaFileHelper = _interopRequireDefault(require("../../../helpers/CordovaFileHelper"));

var _Image = _interopRequireDefault(require("../Image/Image"));

var Topic = function Topic(_ref) {
  var topic = _ref.topic,
      isActive = _ref.isActive,
      changeTopic = _ref.changeTopic,
      day = _ref.day,
      path = _ref.path,
      _ref$topic = _ref.topic;
  _ref$topic = _ref$topic === void 0 ? {} : _ref$topic;
  var topicImage = _ref$topic.topicImage;

  var filePath = _CordovaFileHelper["default"].getDataFolder();

  var imgPath = "".concat(filePath).concat(topicImage);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_Topic["default"].container, " ").concat(isActive ? _Topic["default"].activeCtn : null),
    onClick: function onClick() {
      return changeTopic(topic, path);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _Topic["default"].textCtn
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _Topic["default"].title
  }, topic.topicText), /*#__PURE__*/_react["default"].createElement("div", {
    className: _Topic["default"].progress
  }, day ? "Fortschritt: Tag ".concat(Math.min(day, 14), "/14") : 'Du hast dieses Thema noch nicht begonnen.')), /*#__PURE__*/_react["default"].createElement("div", {
    className: _Topic["default"].imageCtn
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _Topic["default"].imageCtn
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _Topic["default"].helper
  }), /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    alt: "active image",
    className: "".concat(_Topic["default"].image, " ").concat(isActive ? _Topic["default"].activeImg : null),
    src: imgPath
  }))));
};

var _default = Topic;
exports["default"] = _default;